import axios from "axios";

import * as APITypes from "../constants/API";
import StorageKeys from "../constants/StorageKeys";
import SPRM_ENUM from "constants/SPRM_constants";

const fetchNavigationScreen = async () => {
  let agentId;
  const urlParams = new URLSearchParams(location.search);
  //agentId = urlParams.get(SPRM_ENUM.AGENT_ID) || localStorage.getItem(StorageKeys.AGENT_ID,);
  agentId = sessionStorage.getItem(StorageKeys.SET_AGENT_ID_SESSION_STORAGE)

  const response = await axios.get(
    `${APITypes.CHECK_NAVIGATION_SCREEN}?item=${agentId}`
  );
  // if (response?.status?.toLowerCase() === "success") {
  //   localStorage.setItem(
  //     StorageKeys.SHOW_NEW_OPTIMIZATION,
  //     response?.data?.show_new_optimization ? 'customization' : 'customization-old'
  //   );
  // } else {
  //   localStorage.setItem(StorageKeys.SHOW_NEW_OPTIMIZATION, 'customization-old');
  // }
  localStorage.setItem(StorageKeys.SHOW_NEW_OPTIMIZATION, 'customization');

};

export default fetchNavigationScreen;
